import React from 'react';
import { Link } from 'react-router-dom';
import { TAGLINE } from '../constants/brand';

const Footer = () => (
  <footer
    style={{
      background: 'white',
      borderTop: '1px solid #f0f0f0',
      padding: '1.5rem 0',
      marginTop: 'auto',
    }}
  >
    <div className="container">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5rem',
          textAlign: 'center',
        }}
      >
        {/* Brand */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem' }}>
          <img src="/TournNextTeal-WithoutTagline.svg" alt="TournNext" style={{ height: 32, width: 'auto' }} />
          <p style={{ fontSize: '0.75rem', color: '#9ca3af', margin: 0, fontStyle: 'italic' }}>{TAGLINE}</p>
        </div>

        {/* Nav links */}
        <nav style={{ display: 'flex', gap: '1.25rem', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0.25rem' }}>
          {[
            ['/tournaments', 'Tournaments'],
            ['/players', 'Players'],
            ['/sports', 'Sports'],
            ['/subscription', 'Subscription'],
          ].map(([to, label]) => (
            <Link
              key={to}
              to={to}
              style={{ fontSize: '0.8rem', color: '#6b7280', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = '#0D9488'}
              onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Made in India */}
        <p style={{ fontSize: '0.8rem', color: '#9ca3af', margin: 0 }}>
          Made in India{' '}
          <span role="img" aria-label="Indian flag">🇮🇳</span>
          {' '}with love for the Sporting World{' '}
          <span role="img" aria-label="trophy">🏆</span>
        </p>

        {/* Copyright */}
        <p style={{ fontSize: '0.75rem', color: '#d1d5db', margin: 0 }}>
          &copy; {new Date().getFullYear()} TournNext. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
